<template>
  <div>
    <!-- 右上角的导出Excel按钮和日期选择器 -->
    <el-card class="transit-card">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div>
          <el-date-picker
            v-model="selectedDateRange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="onDateRangeChange"
          >
          </el-date-picker>
        </div>
        <el-button type="primary" @click="exportToExcel" class="export-excel-button">
          导出Excel
        </el-button>
      </div>

      <div v-for="(record, index) in paginatedRecords" :key="index" class="transit-item">
        <el-tag :type="record.type === '进入' ? 'success' : 'warning'">
          {{ record.type }}
        </el-tag>
        <span class="time">{{ formatTime(record.timestamp) }}</span>
        <div class="user-info">
          <span>工号：{{ record.ghxh || "未知" }}</span>
          <span>姓名：{{ record.name || "未知" }}</span>
          <span>性别：{{ record.sex || "未知" }}</span>
          <span>分类：{{ record.fenlei || "未知" }}</span>
        </div>
      </div>
    </el-card>

    <!-- 分页组件 -->
    <div style="text-align: center; margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
    <div >
      <footers/>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import footers from '../components/footer.vue'

export default {
  components: {
    footers
  },
  data() {
    return {
      records: [],
      currentPage: 1,
      pageSize: 10,
      totalRecords: 0, // 记录总数
      selectedDateRange: [], // 用于存储用户选择的日期范围
    };
  },
  mounted() {
    this.loadRecords();
  },
  methods: {
    async loadRecords() {
      try {
        const res = await this.$http.get("/transit-records"); // 确保请求路径与后端一致
        
        // 处理返回的数据，确保所有字段正确映射
        this.records = res.map((record) => ({
          ...record,
          type: record.action === "signin" ? "进入" : "离开",
          timestamp: new Date(record.timestamp),
        }));

        // 更新总记录数
        this.totalRecords = this.records.length;
      } catch (error) {
        console.error("加载记录失败:", error);
        this.$message.error("加载记录失败，请稍后再试");
      }
    },
    formatTime(timestamp) {
      return timestamp.toLocaleString();
    },
    handleSignEvent(newRecord) {
      this.records.unshift({
        ...newRecord,
        type: newRecord.action === "signin" ? "进入" : "离开",
        timestamp: new Date(newRecord.timestamp),
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    onDateRangeChange(value) {
      // 当日期范围改变时，可以在这里处理逻辑
      console.log('Selected date range:', value);
    },
    exportToExcel() {
      if (!this.selectedDateRange || this.selectedDateRange.length !== 2) {
        this.$message.warning("请选择日期范围！");
        return;
      }

      const [startTime, endTime] = this.selectedDateRange;

      this.$http.get("/export-transit-records", {
        params: {
          startTime,
          endTime,
        },
        responseType: 'blob',
      })
      .then(response => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        saveAs(blob, "transit_records.xlsx");
      })
      .catch(error => {
        console.error("导出Excel失败:", error.response ? error.response : error);
        if (error.response && error.response) {
          const reader = new FileReader();
          reader.onload = function(e) {
            try {
              const errorMessage = JSON.parse(e.target.result).message;
              alert(`导出Excel失败: ${errorMessage}`);
            } catch (parseError) {
              alert("导出Excel失败，请稍后再试");
            }
          };
          reader.readAsText(new Blob([error.response]));
        } else {
          alert("导出Excel失败，请稍后再试");
        }
      });
    },
  },
  computed: {
    paginatedRecords() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.records.slice(start, end);
    },
  },
  created() {
    
    
  },
  beforeDestroy() {
    // 清理事件监听器
    this.$off("sign-event", this.handleSignEvent);
  },
  computed: {
    paginatedRecords() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.records.slice(start, end);
    },
  },
};
</script>

<style scoped>
.transit-card {
  position: relative; /* 确保子元素的绝对定位是相对于 .transit-card */
  margin: 20px;
}

.export-excel-button {
  position: absolute;
  top: 2%; /* 距离顶部13% */
  right: 3%; /* 距离右侧4% */
  z-index: 10; /* 确保按钮在其他内容之上 */
}

.transit-item {
  padding: 15px;
  border-bottom: 1px solid #ebeef5;
}

.time {
  margin-left: 20px;
  color: #909399;
}

.user-info {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}
</style>